// Filtered subscriptions
const selectElement = document.getElementById('filter_by');

if (selectElement) {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedValue = urlParams.get('filter_by');

  if (selectedValue) {
    selectElement.value = selectedValue;
  }

  selectElement.addEventListener('change', function() {
    const selectedValue = selectElement.value;

    const url = window.location.pathname + '?filter_by=' + selectedValue;

    setTimeout(function() {
      window.location.href = url;
    }, 500);
  });
}

// Admin dashboard
$(document).ready(function () {
  const $loader = document.getElementById('loader');

  if (!$loader) return;

  const $sumWalletBalanceKpi = document.getElementById('sumWalletBalanceKpi');
  const sumBalancePath = $sumWalletBalanceKpi.dataset['sumBalancePath'];
  const sumWalletBalance = $sumWalletBalanceKpi.dataset['sumWalletBalance'];

  // to trigger a manual refresh
  $(document).on('click', '.refresh-link a', function(e) {
    e.preventDefault();
    $loader.textContent = "Chargement en cours";

    refreshInvestorsBalance($loader, sumBalancePath, true);
  });

  // auto refresh
  if (sumWalletBalance === undefined) {
    refreshInvestorsBalance($loader, sumBalancePath);
  } else {
    $loader.textContent = formatAsCurrency(sumWalletBalance);
  }
});

const refreshInvestorsBalance = (loader, sumBalancePath, manual = false) => {
  const interval = window.setInterval(() => {
    const investors_balance_sum = fetchInvestorsBalanceSum(sumBalancePath, manual);
    if (typeof investors_balance_sum === 'number') {
      loader.textContent = formatAsCurrency(investors_balance_sum);
      clearInterval(interval);
    }
  }, 10000);
};

const fetchInvestorsBalanceSum = (sumBalancePath, force_refresh = false) => {
  const request = new XMLHttpRequest();
  let sumBalanceUrl = sumBalancePath;
  if (force_refresh) {
    sumBalanceUrl += '?force_refresh=' + force_refresh;
  }
  request.open('GET', sumBalanceUrl, false);
  request.send(null);

  if (request.status === 200) {
    const data = JSON.parse(request.responseText);

    return data?.investors_balance_sum;
  }

  return null
}

const formatAsCurrency = (value) =>
  new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
